import { hasAsciiControlOrSpace, isOffsetDateTime, isUuid } from '@/lib/validation';

const canonicalUuid = (value: string | null): value is string =>
  value !== null && isUuid(value) && value === value.toLowerCase();
const LIST_KEYS = ['before_created_at', 'before_user_id'] as const;

export interface UserListState {
  valid: boolean;
  beforeCreatedAt: string | null;
  beforeUserId: string | null;
}

export function userListState(params: URLSearchParams): UserListState {
  const beforeCreatedAt = params.get('before_created_at');
  const beforeUserId = params.get('before_user_id');
  const valid =
    [...params.keys()].every((key) => LIST_KEYS.includes(key as (typeof LIST_KEYS)[number])) &&
    LIST_KEYS.every((key) => params.getAll(key).length <= 1) &&
    ((beforeCreatedAt === null && beforeUserId === null) ||
      (beforeCreatedAt !== null &&
        beforeUserId !== null &&
        isOffsetDateTime(beforeCreatedAt) &&
        beforeCreatedAt.length <= 64 &&
        canonicalUuid(beforeUserId)));
  return { valid, beforeCreatedAt, beforeUserId };
}

export function userReturnTo(value: string | null): string {
  if (
    !value ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    value.includes('\\') ||
    hasAsciiControlOrSpace(value)
  )
    return '/users';
  try {
    const url = new URL(value, 'https://internal.invalid');
    if (
      url.origin !== 'https://internal.invalid' ||
      url.pathname !== '/users' ||
      url.hash ||
      !userListState(url.searchParams).valid
    )
      return '/users';
    return url.pathname + url.search;
  } catch {
    return '/users';
  }
}

export function userDetailHref(userId: string, returnTo: string): string {
  return `/users/${userId}?${new URLSearchParams({ returnTo: userReturnTo(returnTo) })}`;
}

export function userDetailState(params: URLSearchParams) {
  const returnTo = params.get('returnTo');
  return {
    valid:
      params.getAll('returnTo').length <= 1 &&
      [...params.keys()].every((key) => key === 'returnTo'),
    returnTo: userReturnTo(returnTo),
  };
}
